import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"add\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M9 7.5v-6c0-.5-.5-1-1-1s-1 .5-1 1v6H1.5c-.6 0-1 .4-1 1s.4 1 1 1H7v6c0 .5.5 1 1 1s1-.5 1-1v-6h5.5c.6 0 1-.4 1-1s-.4-1-1-1H9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol